import Vue from 'vue'

export var globalConf = new Vue({
    data: {
        //hostlink: 'http://vi.benchmarkpro.it/api/' //VI
        //hostlink: 'http://tv.benchmarkpro.it/api/' //TV
        hostlink: 'https://bz.benchmarkpro.it/api/' //BZ
        //hostlink: 'http://bo.benchmarkpro.it/api/' //BO
        //hostlink: 'http://localhost/'
    }
})

//Imposta ricavi

//BO
/*
var ricavi = [[2500.00, 25000.00],
  [25000.00, 50000.00],
  [50000.00]]
*/

//BZ

var ricavi = [[50000.00, 200000.00],
    [200000.00, 500000.00],
    [500000.00]]

export var ricavi = ricavi

//Base dati utili a sidebar
export var sidebarData = new Vue({
    data: {
        data: {
            aziende: [],
            zona: {
                loaded: false,
                data: [
                    { id: 0, nome: 'Tutte le zone' }
                ]
            },
            anno: {
                loaded: false,
                data: [
                    { value: null, text: 'Selezionare un anno' }
                ]
            },
            trimestre: [
                { value: null, text: 'Selezionare un trimestre' },
                { value: 1, text: 'Primo trimestre' },
                { value: 2, text: 'Secondo trimestre' },
                { value: 3, text: 'Terzo trimestre' },
                { value: 4, text: 'Quarto trimestre' }
            ],
            categoria: {
                loaded: false,
                data: [
                    { id: null, nome: 'Selezionare una categoria' }
                ]
            },
            sottocategoria: [
                { id: null, nome: '' }
            ],
            ricavi: [
                { value: null, text: 'Selezionare un range di ricavi' },
                { value: 1, text: setRicavi(ricavi[0][0])+' - '+setRicavi(ricavi[0][1]) },
                { value: 2, text: setRicavi(ricavi[1][0])+' - '+setRicavi(ricavi[1][1]) },
                { value: 3, text: setRicavi(ricavi[2][0])+' in su' }
            ]
        }
    }
})

//Base dati utili a sidebar
export var sidebarValue = new Vue({
    data: {
        ricerca: '',
        zona: 0, 
        anno1: null,
        anno2: null,
        trimestre1: null,
        trimestre2: null,
        categoria: null,
        sottocategoria: null,
        ricavi: null,
        criterio: false,
        azienda: {},
        info: []
    }
})

function setRicavi(n){
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n)
}